/**
 * Constantes pour les messages à afficher dans les tuiles du bandeau météo
 */
export const MessagesEcoWatt = {
  VERT: 'Signal vert',
  ROUGE: 'Système électrique très tendu',
  ORANGE: 'Système électrique tendu',
  GRIS: 'Prévisions à venir à 17h30 (12h30 le vendredi)',
};
